<template>
  <BaseModal :model-value="true" ariaLabel="Edit Patient" @close="onCancel">
    <template #header>
      <div class="modal-header">
        <h5 class="modal-title">Edit Patient</h5>
      </div>
    </template>

    <div class="modal-body">
      <div v-if="editForm">
        <div class="mb-3">
          <label class="form-label">Name</label>
          <input class="form-control" v-model.trim="form.name" />
        </div>

        <div class="mb-3">
          <label class="form-label">Phone</label>
          <input class="form-control" v-model.trim="form.phone_number" />
        </div>

        <div class="mb-3">
          <label class="form-label">Date of Birth</label>
          <input class="form-control" v-model="form.date_of_birth" type="date" />
        </div>

        <div v-if="saveError" class="alert alert-danger">{{ saveError }}</div>
      </div>
    </div>

    <template #footer>
      <div class="modal-footer mt-4">
        <button class="btn btn-outline-dark me-4" @click="onCancel">Cancel</button>

        <button class="btn btn-primary" @click="editPatient" :disabled="isSaving">
          <span v-if="isSaving">Saving…</span>
          <span v-else>Save</span>
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import { ref } from 'vue'
import BaseModal from '@/components/ui/BaseModal.vue'
import { useToast } from 'vue-toastification'
import { updatePatientService } from "@/services/api/patientService"
// eslint-disable-next-line 
const props = defineProps({
  selectedPatient: { type: Object, required: true },
  editForm: { type: Object, required: true },
  patientId: { type: [ Number], required: true }
})
// eslint-disable-next-line 
const emit = defineEmits(["close"])

const toast = useToast()

const isSaving = ref(false)
const saveError = ref("")

const onCancel = () => emit("close", null)
const form = ref({
  name: props.editForm.name,
  phone_number: props.editForm.phone_number,
  date_of_birth: props.editForm.date_of_birth,
})
const editPatient = async () => {
  if (!props.selectedPatient) return;
  isSaving.value = true;
  saveError.value = "";

  const updateFields = {
    name: form.value.name,
    phone_number: form.value.phone_number,
    date_of_birth: form.value.date_of_birth,
  };
  const result = await updatePatientService(props.patientId, updateFields);

  toast.success(result.message)
  emit("close", { updated: true })
  isSaving.value = false
}
</script>
